import 'core-js/fn/map';
import 'core-js/fn/set';
import 'core-js/fn/weak-map';
import 'core-js/fn/weak-set';
import 'core-js/es6/promise';
import 'core-js/es7/promise';
import 'core-js/fn/object/assign';
import 'core-js/fn/object/values';
import 'core-js/fn/object/entries';
import 'core-js/fn/string/starts-with';
import 'core-js/fn/string/ends-with';
import 'core-js/fn/string/includes';
import 'core-js/fn/array/fill';
import 'core-js/fn/array/of';
import 'core-js/fn/array/find';
import 'core-js/fn/array/find-index';
import 'core-js/fn/array/includes';
import 'core-js/fn/array/keys';
import 'core-js/fn/array/values';
import 'core-js/fn/number/is-integer';
import 'core-js/web/timers';
import 'core-js/fn/dom-collections/iterator';
// https://gist.github.com/bob-lee/e7520bfcdac266e5490f40c2759cc955
// for IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function forEach(callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

async function polyfill() {
  if (Intl.DateTimeFormat && !Intl.DateTimeFormat.prototype.formatToParts) {
    await import('../formatToParts');
  }
}

(async () => {
  try {
    await polyfill();
  } catch (e) {
    throw new Error(e);
  }
})();
